<template>
  <el-card
    shadow="hover"
    :body-style="{ padding: '5px' }"
    class="lesson"
    :style="{
      backgroundColor:
        type === 1 ? 'rgba(77,142,246,0.2)' : 'rgba(230,156,62,0.1)',
    }"
  >
    <div
      class="header"
      :style="{ backgroundColor: type === 1 ? '#4D8EF6' : '#E69C3E' }"
    >
      <span>{{ type === 1 ? "獨立考試" : "課堂考試" }}</span>
    </div>
    <p class="title omit" :title="title">{{ title }}</p>
    <div class="time">
      <div v-if="type === 1">
        <p style="margin-bottom: 10px">開始時間：{{ startTime }}</p>
        <p>結束時間：{{ endTime }}</p>
      </div>
      <span v-else class="lessons-name" :title="lessonsName"
        >課堂名稱： {{ lessonsName }}</span
      >
    </div>
    <div class="time">
      <i class="el-icon-time"></i>
      <p>預計考試時長 {{ timeDuration }} mins</p>
    </div>
    <div class="seal" v-if="status != 1 && history_count > 0">
      <img src="@p/assets/images/disable.png" alt="" />
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    timeDuration: {
      type: Number,
      default: 0,
    },
    type: {
      // 0 依赖课堂 1 不依赖课堂
      type: Number,
      default: 0,
    },
    lessons: {
      type: Array,
      default: () => {
        return [];
      },
    },
    startTime: {
      type: String,
      default: "",
    },
    endTime: {
      type: String,
      default: "",
    },
    status: {
      type: Number,
      default: 1,
    },
    history_count: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lessonsName: "",
    };
  },
  created() {
    this.initLessonsName(this.lessons);
  },
  methods: {
    initLessonsName(lessons) {
      const lessonsName = [];
      lessons.forEach((lesson) => {
        lessonsName.push(lesson.name);
      });
      this.lessonsName = lessonsName.join(",");
    },
  },
};
</script>
<style lang="less" scoped>
.el-card,
.el-message {
  border-radius: 8px;
}
.lesson {
  position: relative;
  width: 230px;
  height: 190px;
  background: rgba(77, 142, 246, 0.1);
  .seal {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 42px;
    height: 40px;
    img {
      display: block;
      width: 42px;
      height: 40px;
    }
  }
  .title {
    margin-top: 13px;
    height: 22px;
    font-size: 16px;
    line-height: 22px;
    color: #404040;
  }
  .header {
    width: 220px;
    height: 40px;
    text-align: center;
    color: #fff;
    font-weight: 600;
    font-size: 17px;
    line-height: 40px;
    margin-bottom: 20px;
    background-color: #4d8ef6;
    border-radius: 6px 6px 0px 0px;
  }
  .time {
    display: flex;
    margin-top: 10px;
    width: 230px;
    font-size: 13px;
    color: #333333;
    line-height: 13px;
    p {
      margin-left: 4px;
      margin-bottom: 4px;
    }
    .lessons-name {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      display: inline-block;
      word-break: break-all;
      width: 220px;
    }
  }
}
</style>